'use strict';

/**
 * Component for length
 *
 * @category   View
 * @module     collection.edit
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ItemView = require('base/Colido.ItemView');

var template = require('../../templates/components/field-length.hbs');

var LengthComponent = ItemView.extend({
    template: template,

    className: function() {
        var field = this.getOption('field');

        return 'form-component component-' + _.camelToHyphen(field.type);
    },

    ui: function(){
        var field = this.getOption('field');

        return {
            'inputValue': '[name="' + field.name + '"]',
            'selectUnit': 'select[name="' + field.unitField + '"]',
        };
    },

    viewData: {
        field: function() {
            return this.getOption('field');
        },

        isGroupChild: function() {
            return this.getOption('isGroupChild');
        },
    },

    /**
     * Resets the states and data of the component
     */
    reset: function() {
        var field = this.getOption('field');

        // Render select length unit
        this.renderSelectOptions(
            this.ui.selectUnit,
            App.BaseModule.sizeUnitsCollection,
            'key',
            'key',
            function(option) {
                return this.model && this.model.get(field.unitField) == option.value;
            }.bind(this)
        );
    },

    onShow: function() {
        this.reset();
    },

    getData: function() {
        var data = {};
        var field = this.getOption('field');

        var length = this.ui.inputValue.val().trim();
        var lengthUnit = this.ui.selectUnit.val().trim();

        data[field.name] = length;
        data[field.unitField] = lengthUnit;

        return data;
    },
});

module.exports = LengthComponent;